import { useState } from 'react';
import { ConfirmModal } from './ConfirmModal';
import { useConfirmPurchaseFault } from '../hooks';
import type { AdminPaymentRow } from '../types';

/**
 * D-19: confirm a product fault our system could not detect itself (e.g. an image not mapped) after checking
 * the customer's report. Opens the customer's 24-hour product-fault refund window from now.
 */
export function ConfirmFaultModal({ open, payment, onClose }: { open: boolean; payment: AdminPaymentRow; onClose: () => void }) {
  const mutation = useConfirmPurchaseFault(payment.userId);
  const [reason, setReason] = useState('');
  return (
    <ConfirmModal
      open={open}
      title="Confirm product fault"
      description="Use this only after checking the invitation/template in our system. The customer's 24-hour window to request a refund for a product problem opens now."
      confirmLabel="Confirm fault"
      loading={mutation.isPending}
      disableConfirm={reason.trim().length < 10}
      onClose={onClose}
      onConfirm={() => void mutation.mutateAsync({ invoiceId: payment.id, reason: reason.trim() }).then(onClose)}
    >
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        rows={3}
        placeholder="What did you verify? e.g. image not mapped in the template (min 10 chars)"
        className="w-full px-3 py-2 rounded-lg bg-surface-container-lowest border border-border-subtle text-sm"
      />
      {mutation.error && <p className="text-xs text-red-300 mt-1">{(mutation.error as Error).message}</p>}
    </ConfirmModal>
  );
}
